var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex p-20 justify-content-center" }, [
    _c("div", { staticClass: "p-3 bg-white container br-8" }, [
      _c("div", { staticClass: "alert alert-danger pt-4 m-0" }, [
        _c("p", [
          _c("strong", [
            _c("i", { staticClass: "lh-inherit far fa-info-circle" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Task not found"))),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }